import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import {
    OffsetIconCollection,
    iconDataProps
} from "@/patterns/offset-icon-collection/offset-icon-collection";

export const IntegrationsSection = () => {
    const { createAnalyticsEvent } = useAnalyticsEvents();

    const iconData: iconDataProps[] = [
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ms-teams.webp",
            altText: "Microsoft Teams icon"
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive.webp",
            altText: "Google Drive icon"
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs.webp",
            altText: "Google Docs icon"
        },

        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/figma.webp",
            altText: "Figma icon"
        },

        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/miro.webp",
            altText: "Miro icon"
        },

        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/slack.webp",
            altText: "Teams icon"
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom.webp",
            altText: "Zoom icon"
        }
    ];

    const handleClick = () => {
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-integrations-button-clicked",
                section: "integration-section"
            }
        }).fire();
    };

    return (
        <OffsetIconCollection
            headingText="Meets teams where they work"
            bodyText="Work is easier when tools talk. There’s over 2,500 apps in the Atlassian Marketplace, with integrations that are seamless, you forget what product you’re working out of."
            iconData={iconData}
            ctaText="See all integrations"
            ctaLink="https://marketplace.atlassian.com"
            ctaOnClickFunc={handleClick}
        />
    );
};
IntegrationsSection.displayName = "IntegrationsSection";
